export enum SIZES {
  NAVBAR_HEIGHT = '5.6rem',
}
